import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
  Box,
  Button,
  TextField,
  InputAdornment,
  Card,
} from "@mui/material";
import {
  useDeleteRestaurantMutation,
  useGetRestaurantQuery,
} from "../../../Api/attoDeskApi";
import { IRestaurant } from "../../../Api/Interface/api.interface";
import NewPopUpDepartment from "../Edit/index";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import { useNotifier } from "../../../Core/Notifier";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { CiSearch } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import Pagination from "../../../Components/Pagination";
import AlertPopUp from "../../../Components/AlertPopUp/AlertPopup";
import { formatPhoneNumberForDisplay } from "../../../Components/Validation/validationUtils";
import { toProperCase } from "../../../Components/Validation/toProperCase";

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const debouncedSearchQuery = useDebounce(searchQuery, 300);

  const [selectedCoursing, setSelectedCoursing] = useState<IRestaurant | null>(null);

  const [openDialog, setOpenDialog] = useState(false);
  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] = useState<IRestaurant | null>(null);

  const [deleteAlert, setDeleteAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const { data, isLoading, isError, refetch } = useGetRestaurantQuery({
    searchText: currentSearchQuery,
    id: "",
  });

  useEffect(() => {
    if (debouncedSearchQuery.length >= 4 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleOpenDeletePopup = (coursing: IRestaurant) => {
    setCoursingToDelete(coursing);
    setOpenDeleteCategory(true);
  };

  const handleCloseDeletePopup = () => {
    setCoursingToDelete(null);
    setOpenDeleteCategory(false);
  };

  const [deleteCategory] = useDeleteRestaurantMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpenDeleteCategory(false);
      } else {
        setAlertMessage(response.message);
        setDeleteAlert(true);
      }
    } catch (error) {
      showErrorMessage("Failed to delete the department");
    }
  };

  if (isLoading)
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );

  const coursings: IRestaurant[] = Array.isArray(data?.data)
    ? (data?.data as IRestaurant[])
    : [];

  const handleAddProductClick = () => {
    navigate("/branch/create");
  };

  return (
    <Card className={classes.card}>
      <Grid
        container
        justifyContent={"space-between"}
        spacing={5}
        sx={{ borderBottom: 2, padding: 2 }}
        className={classes.titleGrid}
      >
        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          xs={12}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Grid
            container
            spacing={1}
            justifyContent="flex-end"
            sx={{ display: "flex" }}
          >
            <Grid item>
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CiSearch className={classes.searchWidgetIcon} />
                    </InputAdornment>
                  ),
                  classes: {
                    root: classes.formControlList,
                  },
                }}
                fullWidth
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Branch Name .."
                className={classes.searchTextField}
                size="small"
              />
            </Grid>

            <Grid item>
              <Button
                // variant="contained"
                className={classes.addNewButton}
                onClick={handleAddProductClick}
              >
                Add New
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid>
        <TableContainer>
          <Table className={classes.table}>
            <TableHead className={classes.tableHeaderRow}>
              <TableRow>
                <TableCell className={classes.tablheader}>
                  <strong>Branch Name</strong>
                </TableCell>
                <TableCell className={classes.tablheader}  sx={{ textAlign: "center" }}>
                  <strong>Phone Number</strong>
                </TableCell>
                <TableCell className={classes.tablheader}  sx={{ textAlign: "center" }}>
                  <strong>E-mail</strong>
                </TableCell>
                <TableCell
                  className={classes.tablheader}
                  sx={{ textAlign: "right" }}
                >
                  <strong>Actions</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isError || coursings.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={20} align="center">
                    {isError ? "Error fetching data" : "No data available"}
                  </TableCell>
                </TableRow>
              ) : (
                coursings
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row: IRestaurant, index) => (
                    <TableRow key={row.id} className={classes.tableRowHover}>
                      <TableCell
                        component="th"
                        scope="row"
                        className={classes.tablCell}
                      >
                        {toProperCase(row.restaurantsName)}
                      </TableCell>
                      <TableCell
                        scope="row"
                        className={classes.tablCell}
                        sx={{ textAlign: "center" }}
                      >
                        {formatPhoneNumberForDisplay(row.restaurantsPhoneNumber)}
                      </TableCell>
                      <TableCell
                        scope="row"
                        className={classes.tablCell}
                        sx={{ textAlign: "center" }}
                      >
                        {row.restaurantsEmail}
                      </TableCell>
                      <TableCell className={classes.tablCell}>
                        <Grid
                          container
                          spacing={1}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Grid item>
                            <Button
                              className={classes.editButtonList}
                              onClick={() =>
                                navigate(`/branch/edit/${row.id}`)
                              }
                            >
                              <EditSharpIcon className={classes.editListIcon} />
                            </Button>
                          </Grid>
                          <Grid item>
                            <Button
                              className={classes.deleteButtonList}
                              onClick={() => handleOpenDeletePopup(row)}
                            >
                              <DeleteOutlineSharpIcon
                                className={classes.deleteListIcon}
                              />
                            </Button>
                          </Grid>
                        </Grid>
                      </TableCell>
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
          <Grid
            spacing={5}
            p={"18px"}
            py={4}
            justifyContent={"end"}
            container
            textAlign={"center"}
            alignContent={"center"}
            alignItems={"center"}
          >
            <Grid
              sx={{
                textAlign: "end",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <Pagination
                count={coursings.length}
                page={page}
                rowsPerPage={rowsPerPage}
                onPageChange={handleChangePage}
              />
            </Grid>
          </Grid>
        </TableContainer>
        {/* {selectedCoursing && (
          <NewPopUpDepartment
            openModel={openDialog}
            handleCloseDialog={handleCloseDialog}
            data={selectedCoursing}
          />
        )} */}
        {coursingToDelete && (
          <DeletePopup
            open={openDeleteCategory}
            handleCloseDelete={handleCloseDeletePopup}
            onConfirm={async () => {
              await handleDelete(coursingToDelete.id.toString());
            }}
            title="Delete Branch"
            content={`Are you sure you want to delete "${coursingToDelete.restaurantsName}"?`}
          />
        )}

        <AlertPopUp
          open={deleteAlert}
          onCloseAlert={setDeleteAlert}
          message={alertMessage}
        />
      </Grid>
    </Card>
  );
};

export default Index;
